// extracted by mini-css-extract-plugin
module.exports = {"cardsControls":"cardControls_cardsControls__2UFeF","cardsCount":"cardControls_cardsCount__LLF3x"};